import { createSelector } from 'reselect';

const selectDomain = (state) => state.deck;

export const selectDrawing = createSelector(
  [selectDomain], (state) => state.get('drawing'),
);